export function priceClasses({ baseClass, currencyVerticalAlignment, decimalVerticalAlignment, currencyPosition, currencySpacing, strikeoutPrice, fixedSize, subtle, bti, size, regularFontWeight, class: _class, className }) {
    const classes = [
        baseClass,
        currencyPosition === 'leading' && `${baseClass}--leading`,
        currencyPosition === 'trailing' && `${baseClass}--trailing`,
        currencySpacing !== 'none' && `${baseClass}--currency-${currencySpacing}`,
        !strikeoutPrice && fixedSize && `${baseClass}--fixed-size`,
        currencyPosition && `${baseClass}--${currencyPosition}`,
        size && `${baseClass}--${size}`,
        subtle && `${baseClass}--subtle`,
        strikeoutPrice && `${baseClass}--strikeout`,
        !bti && regularFontWeight && `${baseClass}--regular-font-weight`,
        bti && `${baseClass}--bti-price`,
        !fixedSize && !strikeoutPrice && currencyVerticalAlignment && `${baseClass}--currency-${currencyVerticalAlignment}-aligned`,
        !fixedSize && !strikeoutPrice && decimalVerticalAlignment && `${baseClass}--decimal-${decimalVerticalAlignment}-aligned`,
        _class,
        className
    ].filter(Boolean).join(' ');
    return classes;
}
export function generateAriaLabel({ captionPrefix, captionSuffix, negativeSign, currencyPosition, currencyLabel, decimalSign, decimalValue, subscriptLabel, integerValue }) {
    const ariaIntegerValue = integerValue ? integerValue.replace(/\s|\.|,/g, '') : '';
    return [
        captionPrefix,
        negativeSign,
        currencyPosition === 'leading' ? currencyLabel : '',
        [
            negativeSign ? ariaIntegerValue.slice(1) : ariaIntegerValue,
            decimalSign && decimalValue ? decimalSign : '',
            decimalValue && decimalSign ? decimalValue : '',
            currencyPosition === 'trailing' ? currencyLabel : '',
            subscriptLabel
        ].filter(Boolean).join(''),
        captionSuffix
    ].filter(Boolean).join(' ');
}
export function getNegativeSign({ integerValue = '' }) {
    if (!integerValue) {
        return null;
    }
    return (integerValue[0] === '−' || integerValue[0] === '-') ? '−\u00A0' : null;
}
export function getElementType({ bti }) {
    return bti ? 'em' : 'span';
}
